export default "__VITE_ASSET__CUj3OWCg__"